import React from 'react';
import { Menu, Icon, Image } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { signIn, signOut, fetchCollections, fetchStatistics } from '../actions';

class GoogleAuth extends React.Component {
    componentDidMount(){
        const developmentId = '187403861195-o3aktu4rm21h9dcdo1jo8u2m88keud3r.apps.googleusercontent.com'
        const productionId = '525156860841-hur7aurgc7u953baou5su02620kdj8kk.apps.googleusercontent.com'
        const clientId = process.env.REACT_APP_STAGE === 'production' ? productionId : developmentId;
        
        window.gapi.load('client:auth2', () => {
            window.gapi.client.init({
                clientId: clientId,
                scope: 'profile'
            }).then(() => {
                this.auth = window.gapi.auth2.getAuthInstance();
                this.onAuthChange(this.auth.isSignedIn.get());
                this.auth.isSignedIn.listen(this.onAuthChange)
            })
        });
    }

    onAuthChange = isSignedIn => {
        if (isSignedIn) {
            const userId = this.auth.currentUser.get().getId();
            const email = this.auth.currentUser.get().getBasicProfile().getEmail();
            const imageUrl = this.auth.currentUser.get().getBasicProfile().getImageUrl();
            const token = this.auth.currentUser.get().getAuthResponse().id_token;
            this.props.signIn(userId, email, imageUrl, token);
            this.props.fetchCollections(this.props.year, token);
            this.props.fetchStatistics(this.props.year, token);
        } else {
            this.props.signOut();
        }
    }

    onSignInClick = () => {
        this.auth.signIn();
    }

    onSignOutClick = () => {
        this.auth.signOut();
    }

    renderAuthButton(){
        if(this.props.isSignedIn === null){
            return null;
        }else if (this.props.isSignedIn === true) {
            return (
                <Menu.Item name="signOut" onClick={this.onSignOutClick}  >
                    <Image src={this.props.imageUrl} avatar />
                    <span>{this.props.email}</span>
                </Menu.Item>
            )
        }else {
            return (
                <Menu.Item name="signIn" onClick={this.onSignInClick} >
                    <Icon name="google"/>
                    Sign In with Google
                </Menu.Item>
            )
        }
    }

    render(){
    return <Menu.Menu position="right">{this.renderAuthButton()}</Menu.Menu>;
    }
}

const mapStateToProps = (state) => {
    return { isSignedIn: state.auth.isSignedIn, email: state.auth.email, imageUrl: state.auth.imageUrl, year: state.dashboard.year };
}
export default connect(mapStateToProps, { signIn, signOut, fetchCollections, fetchStatistics})(GoogleAuth);